import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useInternational } from '@/common/locale';
import { useBaseMenuStore } from '@/common/stores/base-menu';
import { storeToRefs } from 'pinia';

export const setup = () => {
  const { t } = useInternational();
  const searchValue = ref<string>('');

  const isMac = /Mac|iPhone|iPod|iPad/i.test(navigator.userAgent);

  const { isShowMenuSearch } = storeToRefs(useBaseMenuStore());

  const showMenuSearchPopup = () => {
    isShowMenuSearch.value = true;
  };

  const handleKeyDown = (e: KeyboardEvent) => {
    if ((isMac ? e.metaKey : e.ctrlKey) && e.key === 'k') {
      e.preventDefault();
      showMenuSearchPopup();
    }
  };

  const onMouseDown = () => {
    showMenuSearchPopup();
  };

  onMounted(() => {
    window.addEventListener('keydown', handleKeyDown);
  });

  onBeforeUnmount(() => {
    window.removeEventListener('keydown', handleKeyDown);
  });

  return {
    t,
    searchValue,
    isMac,
    onMouseDown,
  };
};
